import PropTypes from 'prop-types';
import { fieldInputPropTypes, fieldMetaPropTypes } from 'redux-form';
import React from 'react';
import kebabCase from 'kebab-case';
import { withStyles } from 'material-ui/styles';
import TextField from 'material-ui/TextField';
import { InputAdornment } from 'material-ui/Input';

import styles from '../../../constants/styles';

export class Input extends React.Component {
  constructor(props) {
    super(props);
    const { input, inverseConv } = props;
    const { value } = input;
    const displayValue = inverseConv ? inverseConv(value) : value;
    this.state = { value: displayValue };
    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  onEvent(event) {
    const { convert } = this.props;
    const { target } = event || {};
    const { value } = target || {};
    const restoredVal = convert && value ? convert(value) : value;

    this.setState({ value });
    return restoredVal;
  }

  onChange(event) {
    const { input } = this.props;
    const value = this.onEvent(event)
    input.onChange(value);
  }

  onBlur(event) { 
    const { input } = this.props;
    const value = this.onEvent(event)
    input.onBlur(value);
  }

  render() {
    const {
      classes,
      id,
      label,
      input,
      type,
      meta,
      min,
      max,
      step,
      required,
      fullWidth,
      suffix,
      helper,
      // these are here to remove from ...rest
      convert,
      inverseConv,
      ///
      ...rest
    } = this.props;
    const { error, warning, touched } = meta;
    const { value } = this.state;

    const hasError = (touched && ( error || warning )) ? true : false;
    const helperText = hasError ? ( error || warning ) : helper;
    const fieldId = id || kebabCase(input.name);
    const endAdornment = suffix
      ? <InputAdornment position="end">{suffix}</InputAdornment>
      : undefined;
    const inputProps = { min, max, step };
    const muInputProps = endAdornment ? { endAdornment } : {}

    return (
      <TextField
        className={classes.textFeild}
        id={fieldId}
        label={label}
        type={type}
        required={required}
        helperText={helperText}
        error={hasError}
        fullWidth={fullWidth}
        InputProps={{
          ...muInputProps,
          inputProps
        }}
        {...rest}
        {...input}
        // followings must come after {...input} as to override
        value={value} 
        onChange={this.onChange}
        onBlur={this.onBlur}
      />
    );
  }
}

Input.defaultProps = {
  id: undefined,
  type: 'text',
  min: undefined,
  max: undefined,
  step: undefined,
  placeholder: undefined,
  helper: undefined,
  suffix: undefined,
  required: false,
  fullWidth: false,
  convert: undefined,
  inverseConv: undefined,
}

Input.propTypes = {
  classes:     PropTypes.shape({
    textField: PropTypes.string
  }).isRequired,
  label:       PropTypes.string.isRequired,
  input:       PropTypes.shape(fieldInputPropTypes).isRequired,
  meta:        PropTypes.shape(fieldMetaPropTypes).isRequired,
  id:          PropTypes.string,
  type:        PropTypes.string,
  min:         PropTypes.number,
  max:         PropTypes.number,
  step:        PropTypes.number,
  placeholder: PropTypes.string,
  suffix:      PropTypes.string,
  required:    PropTypes.bool,
  fullWidth:   PropTypes.bool,
  helper:      PropTypes.string,
  convert:     PropTypes.func,
  inverseConv: PropTypes.func,
}

export default withStyles(styles)(Input);



// WEBPACK FOOTER //
// ./src/components/common/formComponents/Input.js